import { useEffect, useRef, useState } from "react";
import config from "../devprodConfig";
import "../App.css";
import { useSearchParams } from "react-router-dom";
import { setSharePointFolderForKiinteisto } from "../api/api";
function SharePoint() {
  const API_URL = config.apiBaseUrl;
  const [currentFolderName, setCurrentFolderName] = useState(null);
  const [currentFolder, setCurrentFolder] = useState(null);
  const [history, setHistory] = useState([]);
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [folderLoading, setFolderLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchParams] = useSearchParams();
  const initialFolderId = searchParams.get("folderId");
  const initialName = searchParams.get("name");
  const fetchRequestRef = useRef(0);
useEffect(() => {
  if (initialFolderId) {
    console.log("📂 Opening from URL:", initialFolderId);

    setCurrentFolder(initialFolderId);
    setHistory([null]);

    fetchFiles(initialFolderId);

  
    setCurrentFolderName(
      initialName && initialName !== "undefined"
        ? initialName
        : "Kansio"
    );

  } else {
    fetchFiles();
  }
}, [initialFolderId, initialName]);

const fetchFiles = async (folderId = null) => {
  const requestId = ++fetchRequestRef.current;

  try {
    setFolderLoading(true);

    let url = `${API_URL}/sharepoint/files`;

    if (folderId) {
      url += `?folderId=${encodeURIComponent(folderId)}`;
    }

  
    const res = await fetch(url, {
      credentials: "include",
    });

    if (!res.ok) {
      throw new Error(
        `SharePoint request failed: ${res.status}`
      );
    }

    const data = await res.json();

    if (requestId !== fetchRequestRef.current) {
      console.log(
        "⚠️ Ignoring old SharePoint response:",
        requestId
      );
      return;
    }

    setFiles(Array.isArray(data) ? data : []);
  } catch (err) {
    if (requestId !== fetchRequestRef.current) {
      return;
    }

    console.error(
      "Failed to fetch SharePoint files:",
      err
    );

    setFiles([]);
  } finally {
    if (requestId === fetchRequestRef.current) {
      setLoading(false);
      setFolderLoading(false);
    }
  }
};

  const uploadFile = async (file) => {
    const formData = new FormData();

    formData.append("file", file);

    if (currentFolder) {
      formData.append("folderId", currentFolder);
    }

    await fetch(`${API_URL}/sharepoint/upload`, {
      method: "POST",
      credentials: "include",
      body: formData,
    });

    fetchFiles(currentFolder);
  };

const goBack = () => {
  if (history.length === 0) return;

  const prev = history[history.length - 1] || null;

  setHistory((oldHistory) =>
    oldHistory.slice(0, -1)
  );

  setCurrentFolder(prev);
  setSearchTerm("");

  if (!prev) {
    setCurrentFolderName(null);
  } else {
    setCurrentFolderName("Kansio");
  }

  fetchFiles(prev);
};

const openFolder = (file) => {
  setHistory((prev) => [
    ...prev,
    currentFolder
  ]);

  setCurrentFolder(file.id);
  setCurrentFolderName(file.name);
  setSearchTerm("");

  fetchFiles(file.id);
};

  const filteredFiles = files.filter((file) =>
    file.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="container py-4">
      <div className="sharepoint-page-header">
        <div>
          <h2 className="mb-1">SharePoint</h2>
          <p className="text-muted mb-0">
            Selaa SharePoint-tiedostoja ja kansioita.
          </p>
        </div>
      </div>

      <input
        id="sharepointUploadInput"
        type="file"
        multiple
        style={{ display: "none" }}
        onChange={async (e) => {
          const selectedFiles = Array.from(e.target.files || []);

          for (const file of selectedFiles) {
            await uploadFile(file);
          }

          e.target.value = "";
        }}
      />

      <div className="sharepoint-card">
        <div className="sharepoint-toolbar">
          <div className="sharepoint-breadcrumb">
            <i className="bi bi-folder-fill"></i>
            <span>
  {currentFolder
    ? currentFolderName || "Kansio"
    : "Juuri"}
</span>
          </div>

          <div className="d-flex gap-2">
            {currentFolder && (
              <>
                <button className="btn btn-outline-secondary" onClick={goBack}>
                  ← Takaisin
                </button>

                <button
                  className="btn btn-success"
                  onClick={() =>
                    document.getElementById("sharepointUploadInput").click()
                  }
                >
                  <i className="bi bi-upload me-2"></i>
                  Lataa tiedosto
                </button>
                
 
              </>
              
            )}
          </div>
        </div>

        <div className="sharepoint-search">
          <i className="bi bi-search"></i>
          <input
            type="text"
            placeholder="Hae tiedostoja tai kansioita..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {loading || folderLoading ? (
          <div className="sharepoint-spinner">
            <div className="spinner-border text-success" role="status" />
            <div className="text-muted mt-2">Ladataan kansiota...</div>
          </div>
        ) : filteredFiles.length === 0 ? (
          <div className="sharepoint-empty">
            {searchTerm ? "Ei hakutuloksia" : "Ei tiedostoja"}
          </div>
        ) : (
          <div className="sharepoint-grid">
            {filteredFiles.map((file) => (
              <div
                key={file.id}
                className="sharepoint-file-card"
                onClick={() => {
                  if (file.folder) {
                    openFolder(file);
                  } else {
                    window.open(file.webUrl, "_blank");
                  }
                }}
              >
                <div className="sharepoint-file-info">
                  <div className="sharepoint-file-icon">
                    {file.folder ? "📁" : "📄"}
                  </div>

                  <div className="sharepoint-file-text">
                                  <div
                    className="sharepoint-file-name"
                    title={file.name} 
                  >
                    {file.name}
                  </div>
                    <div className="sharepoint-file-meta">
                  {file.folder
                    ? `${file.folder.childCount || 0} kohdetta`
                    : file.size
                      ? `${Math.round(file.size / 1024)} KB`
                      : "Tiedosto"}
                </div>
                  </div>
                </div>

                {!file.folder && (
                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={(e) => {
                      e.stopPropagation();
                      window.open(file.webUrl, "_blank");
                    }}
                  >
                    Avaa
                  </button>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default SharePoint;